export default __webpack_public_path__ + "static/media/filter.f5ae81e4.svg";